/* tslint:disable */
/* eslint-disable */
/* @relayHash 95a2b76054c703ebbe945c64a40e48e2 */

import { ConcreteRequest } from "relay-runtime";
export type useLiveNotificationsPollingQueryVariables = {
    userID: string;
};
export type useLiveNotificationsPollingQueryResponse = {
    readonly notificationCount: number | null;
};
export type useLiveNotificationsPollingQuery = {
    readonly response: useLiveNotificationsPollingQueryResponse;
    readonly variables: useLiveNotificationsPollingQueryVariables;
};



/*
query useLiveNotificationsPollingQuery(
  $userID: ID!
) {
  notificationCount(userID: $userID)
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userID"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "userID",
                    "variableName": "userID"
                }
            ],
            "kind": "ScalarField",
            "name": "notificationCount",
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "useLiveNotificationsPollingQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "useLiveNotificationsPollingQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "95a2b76054c703ebbe945c64a40e48e2",
            "metadata": {},
            "name": "useLiveNotificationsPollingQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '0742b046c39afdc691a3316cd965992a';
export default node;
